module.exports = __webpack_public_path__ + "static/media/xfinity-med.0d287d3e.png";